import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageContext";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const { language, setLanguage, t } = useLanguage();

  return (
    <BottomNavigation className="footer-nav" showLabels>
      <BottomNavigationAction
        label={t("footer.board")}
        // Keep whatever agenda/starttime is already in the URL - a plain
        // navigate("/") would drop the search and look like data loss.
        onClick={() => navigate({ pathname: "/", search: location.search })}
      />
      <BottomNavigationAction
        label={t("footer.ai")}
        onClick={() => navigate("/ai")}
      />
      <BottomNavigationAction
        label={t("footer.imprint")}
        onClick={() => navigate("/imprint")}
      />
      <BottomNavigationAction
        label={t("footer.privacy")}
        onClick={() => navigate("/privacy")}
      />
      <BottomNavigationAction
        label={t("footer.examples")}
        onClick={() => navigate("/examples")}
      />
      {/* Named in the language it switches to, so it can be found by
          someone who can't read the current one. */}
      <BottomNavigationAction
        className="footer-language"
        label={t("footer.switchLanguage")}
        aria-label={t("footer.switchLanguageLabel")}
        lang={language === "de" ? "en" : "de"}
        onClick={() => setLanguage(language === "de" ? "en" : "de")}
      />
    </BottomNavigation>
  );
}
